import React, { Component } from "react";
import Title from "./Title";
import "./about.css";
import resume from "../assets/Nathalie Cortez Front End.pdf";
import englishResume from "../assets/Nathalie Cortez Front End (English).pdf";
import ScrollAnimation from "react-animate-on-scroll";
import nathalie from "../assets/nathalie.jpg";

export default class About extends Component {
  render() {
    return (
      <React.Fragment>
        <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut">
          <section className="about">
            <Title name="About me" />
            <div className="row mt-30">
            <div className="col s12 m5 13">
            <img className="imgAbout" src={nathalie} alt = "Nathalie"/>
            </div>
            <div className="col s12 m7 13">
            <span className="descriptionAbout">
              Front-end developer, antropologist and Musician. One of my
              favorite activities, besides literature, is to learn new things,
              which is why I decided to enter in to the tech world. My long-term
              goal is to be able to generate social change through my code. I am
              interested in being updated on new technologies, so I look for a
              place where I can continue developing my skills and abilities as a
              web developer. Although my first approach with the programming has
              been in front end, I would like later to learn about back-end
              technologies.{" "}
            </span>
            <p className="resume" id={"resume-pdf"}>
              My resume here! view/download it in{" "}
              <a href={englishResume} target="_blank" rel = "noopener noreferrer">
                English
              </a>{" "}
              and{" "}
              <a href={resume} target="_blank" rel = "noopener noreferrer">
                Spanish
              </a>
            </p>
            </div>
            </div>
          </section>
        </ScrollAnimation>
      </React.Fragment>
    );
  }
}
